// JsFromRoutes CacheKey caa35c9366bc3875216c130a82c8045f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  about: /* #__PURE__ */ definePathHelper('get', '/about'),
  press: /* #__PURE__ */ definePathHelper('get', '/press'),
  terms: /* #__PURE__ */ definePathHelper('get', '/legal'),
  tos: /* #__PURE__ */ definePathHelper('get', '/terms'),
  privacy: /* #__PURE__ */ definePathHelper('get', '/privacy'),
  giftagreement: /* #__PURE__ */ definePathHelper('get', '/giftagreement'),
  cardholderagreement: /* #__PURE__ */ definePathHelper('get', '/cardholderagreement'),
  giveawayRules: /* #__PURE__ */ definePathHelper('get', '/giveawayrules'),
  officialRules: /* #__PURE__ */ definePathHelper('get', '/officialrules'),
  howItWorks: /* #__PURE__ */ definePathHelper('get', '/how-it-works'),
  isGiftlyLegit: /* #__PURE__ */ definePathHelper('get', '/trust/is-giftly-legit'),
  demo: /* #__PURE__ */ definePathHelper('get', '/demo'),
}
